export const COLORS = [
    '#4b87cd',
    '#00a064',
    '#fd4444',
    '#ffe119',
    '#f58231',
    '#911eb4',
    '#46f0f0',
    '#f032e6',
    '#d2f53c',
    '#fabebe',
    '#008080',
    '#e6beff',
    '#aa6e28',
    '#fffac8',
    '#800000',
    '#aaffc3',
    '#808000',
    '#ffd8b1',
    '#000080',
    '#808080',
];
export const YEAR_INTERVAL = 24 * 3600 * 1000 * 30 * 12;
export const CHART_SELECTED_PERIOD_COLOR = 'rgba(39, 44, 51, 1)';
export const PAGE_BG_COLOR = 'transparent';
export const TOOLTIP_BACKGROUND = 'var(--dark-grey-1)';
export const WHITE_COLOR = 'var(--white)';
export const AXIS_MASTER_LABEL_DATE_FORMAT = 'yyyy';
export const AXIS_LABEL_DATE_FORMAT = 'MMM-yyyy';
export const AXIS_LABEL_DATE_FORMAT_LONG = 'dd-MMM-yyyy';
export const GRID_LINE_COLOR = '#41454A';
export const MONTHLY_INTERVAL = 24 * 3600 * 1000 * 30;
export const DEFAULT_OPTIONS = {
    chart: {
        backgroundColor: PAGE_BG_COLOR,
    },
    title: {
        text: '',
    },
    subtitle: {
        text: '',
    },
    tooltip: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    exporting: {
        buttons: {
            contextButton: {
                menuItems: [
                    'downloadPNG',
                    'downloadJPEG',
                    'downloadPDF',
                    'downloadSVG',
                ],
            },
        },
    },
    navigation: {
        buttonOptions: {
            theme: {
                fill: '#2c3239',
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                states: {
                    hover: {
                        fill: '#2c3239',
                    },
                    select: {
                        fill: '#2c3239',
                    },
                },
            },
        },
        menuStyle: {
            background: PAGE_BG_COLOR,
            boxShadow: 'none',
            borderColor: '#42474c',
        },
        menuItemStyle: {
            color: 'white',
            fontFamily: 'Source Sans Pro',
        },
        menuItemHoverStyle: {
            backgroundColor: ' #343b44',
        },
    },
};
//# sourceMappingURL=index.js.map